"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var data_parser_1 = __importDefault(require("../../common/src/utils/validation/data_parser"));
var ZipUtils = /** @class */ (function () {
    function ZipUtils() {
    }
    ZipUtils.isValid = function (zipcode) {
        if (!zipcode) {
            return false;
        }
        // 半角に変換
        var hankakuZip = data_parser_1.default.toHankaku(zipcode);
        // 空白があった場合に除去。
        hankakuZip = hankakuZip.trim();
        // 7桁以下は除外。
        if (hankakuZip.length !== 7) {
            return false;
        }
        var zipNumber = Number(hankakuZip);
        return !isNaN(zipNumber);
    };
    ZipUtils.parseZip = function (zipcode) {
        if (!zipcode) {
            return '';
        }
        var hankakuZip = data_parser_1.default.toHankaku(zipcode);
        return hankakuZip.trim();
    };
    ZipUtils.getAddress = function (zipcode) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!ZipUtils.isValid(zipcode)) {
                            return [2 /*return*/, {}];
                        }
                        return [4 /*yield*/, axios_1.default.post(ZipUtils.makeUrl(zipcode), { zipcode: ZipUtils.parseZip(zipcode) })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result['data']];
                }
            });
        });
    };
    ZipUtils.callback = function (result) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (result['results'].length > 1) {
                    return [2 /*return*/, {
                            address1: result['results'][0]['address1'],
                            address2: result['results'][0]['address2'],
                        }];
                }
                return [2 /*return*/, result['results']];
            });
        });
    };
    ZipUtils.makeUrl = function (zipcode) {
        return process.env['API']['INVOKE_URL'] + "get_address";
    };
    Object.defineProperty(ZipUtils, "END_POINT", {
        get: function () {
            return 'https://zip-cloud.appspot.com/api/search?zipcode=';
        },
        enumerable: true,
        configurable: true
    });
    return ZipUtils;
}());
exports.default = ZipUtils;



//////////////////
// WEBPACK FOOTER
// ./src/utils/zip_utils.ts
// module id = NKBT
// module chunks = 1